import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import useSpagQuestions from "../../hooks/useSpagQuestions";
import useGoogleSheets from 'use-google-sheets';

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";


import Keyboard from "../../components/KeyboardSPAG";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function SpagOutwood({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);
  const [gotsheet, setGotSheet] = useState(false);

  //say word stuff
  const { sayWord } = useSpeech();
    const [wordToSay, setWordToSay] = useState("");

    //when question changes play the relevant audio
    useEffect(() => {
      if (currQuestion != undefined){
        console.log("SAY THE WORD");
        console.log(currQuestion);
        setWordToSay(currQuestion.Audio);
        //sayWord(currQuestion.audio);
      }
  }, [currQuestion]);

  useEffect(() => {
    console.log("I should be saying the word");
      sayWordNew(wordToSay);
  }, [wordToSay]);


  function sayWordNew(word) {
      if (word != undefined && word != "") {
        word = word.toLowerCase();
        console.log("playing sound: " + word);
        var audio = new Audio(require("../../assets/Audio/" + word+'.mp3'));
        audio.play();
      }
}

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac
  //4 = multiple choice 2
  var spreadsheetid = "1dhtlhK4RJk6NStXJPxx2f68Ge0jJbH010Z_-D7BjrEE";


  const { data, loadingu, error } = useGoogleSheets({
    apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    sheetId: spreadsheetid,
  });


  useEffect(() => {
    if (data != undefined && data.length > 0){
      console.log(data);
      setGotSheet(true);
    }
  }, [data]);


function SetupQuestions(){
  //use props to determine what to set it as
  for (let i = 0; i < data[0].data.length; i++) {
    const q = data[0].data[i];
    if (q["Term"].toLowerCase().replace(" ", "") == props.assessment_type[2].toLowerCase()){
      if (q["Year"].replace(" ", "") == props.assessment_type[0]){
        questions.push({ "question" : q["Question Line 1"].replace("$", "_"), "question2": q["Question Line 2"], "answer" : q["Answer 1"]+"|"+q["Wrong Answer 2"]+"|"+q["Wrong Answer 3"]+"|"+q["Wrong Answer 4"], "Audio": q["Audio"], "type": 1, "units" : "", "marks" : 1})
      }
    }
  }
}


  



//above is questions section
  
  const [questions, setQuestions] = useState([]);
  console.log(props);

  var timer = -1;

  //SET TIMER BASED ON THESE
  if (status == false && gotsheet == true){
    console.log("I GOT THE SHEET");
    currQuestion = [];
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    SetupQuestions();
    //check what questions it is, checking year first will check terms later like Spring etc
    timer = -1;
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1 || questions[i].type == 4){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        console.log("CHOICES");
        console.log(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  function MultipleButtons() {
    console.log(currentQuestion);
    return "blank"
    

  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length || currQuestion == undefined || currQuestion.question == undefined){
      return blankbg;
    }
    return (require("../../assets/maths_assessments/assets/Spag.png"))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer.toLowerCase() == youranswer.toLowerCase()){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer.toLowerCase() == correct.toLowerCase()){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    let choices = shuffledAnswers[questionNum];
    console.log(shuffledAnswers);
    console.log(choices);

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  function PlayAudio(){
    sayWordNew(wordToSay);
  }

  //I don't know how to comment html/CSS
  return (
    
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="extrascaling">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              <div style={{ width: "80%" }}>
                {currQuestion != undefined && currQuestion.question != undefined ? (


                  <Container update={refresh}>
                    <h1 style={{position: "absolute", top: "23%", right: "45%", fontSize: "6em", textAlign: "center", width: "1300px", height: "200px"}}>
                      {currQuestion['question']} 
                    </h1>
                    <h1 style={{position: "absolute", top: "40%", right: "45%", fontSize: "6em", textAlign: "center", width: "1300px", height: "200px"}}>
                      {currQuestion['question2']} 
                    </h1>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                    {currQuestion.Audio != "" &&
                      <AudioButton onClick={() => PlayAudio()}>
                      <span>Play Audio</span>
                    </AudioButton>
                    });
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <Keyboard
                            onChange={setAnswer}
                            currentQuestion={currQuestion}
                            onSubmitted={checkResult}
                            playAudioButton={false}
                            onPlayAudio={() => {
                              PlayAudio();
                            }}
                            currentAnswer={useranswers[questionNum]}
                        />
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }  
                        </div>
                    </div>

                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                  <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
        </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 35%;
  right: 30%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`

const AudioButton = styled.div`
  position: absolute;
  right: 65%;
  top: 65%;
  text-align: center;
  width: 300px;
  height: 100px;
  line-height: 100px;
  font-size: 3em;
  margin: 5px;
  color: #fff;
  user-select: none;
  background: rgb(234, 146, 19);
  background: linear-gradient(
    0deg,
    rgba(234, 146, 19, 1) 0%,
    rgba(255, 186, 32, 1) 100%
  );
  border: 2px solid #e88f12;
  padding: 0.5em;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
    font-size: 2.5em;
  }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
`;